const state = {
  totals: [],
}

const getters = {
 getTotals: state => state.totals
}
const actions = {
  setTotals ({ commit }, totals) {
    commit('setTotals', totals)
  },

}
const mutations = {
  setTotals (state, totals) {
    state.totals = totals
  },
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
